import { Link } from "react-router-dom";
import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

function Unauthorized() {
  return (
    <VuiBox display="flex" justifyContent="center" alignItems="center" minHeight="70vh" px={2}>
      <Card sx={{ p: 4, maxWidth: 520, width: "100%" }}>
        <VuiTypography variant="h4" color="dark" mb={1}>
          Access denied
        </VuiTypography>
        <VuiTypography variant="button" color="text" display="block" mb={3}>
          Your role does not have permission to view this page.
        </VuiTypography>
        <VuiBox display="flex" gap={1}>
          <Link to="/dashboard">
            <VuiButton color="info">Go to dashboard</VuiButton>
          </Link>
          <Link to="/profile">
            <VuiButton color="dark" variant="outlined">
              Open profile
            </VuiButton>
          </Link>
        </VuiBox>
      </Card>
    </VuiBox>
  );
}

export default Unauthorized;


